import moment from "moment";
import { Button, Col, Form, Row } from "react-bootstrap";
import Card from "./card";

export const DateSelector = ({
	startDate,
	endDate,
	setStartDate,
	setEndDate,
	children
}: {
	startDate: string;
	endDate: string;
	setStartDate: Function;
	setEndDate: Function;
	children?: any;
}) => {
	return (
		<Card title="Chọn thời gian" style={{ marginTop: "16px" }}>
			<Row>
				<Col>
					<Form.Group>
						<Form.Label>Từ ngày:</Form.Label>
						<Form.Control
							type="date"
							value={startDate}
							onChange={(e) => {
								setStartDate(e.target.value);
							}}
						/>
					</Form.Group>
				</Col>
				<Col>
					<Form.Group>
						<Form.Label>Đến ngày:</Form.Label>
						<Form.Control
							type="date"
							value={endDate}
							onChange={(e) => {
								setEndDate(e.target.value);
							}}
						/>
					</Form.Group>
				</Col>
			</Row>
			<Row>
				<Col>
					<Button
						style={{ width: "100px", marginRight: "4px" }}
						onClick={() => {
							const start = moment().subtract(3, "months").format("YYYY-MM-DD");
							const end = moment().format("YYYY-MM-DD");
							setStartDate(start);
							setEndDate(end);
						}}
					>
						3 tháng
					</Button>
					<Button
						style={{ width: "100px", marginRight: "4px" }}
						onClick={() => {
							const start = moment().subtract(1, "months").format("YYYY-MM-DD");
							const end = moment().format("YYYY-MM-DD");
							setStartDate(start);
							setEndDate(end);
						}}
					>
						1 tháng
					</Button>
					<Button
						style={{ width: "100px", marginRight: "4px" }}
						onClick={() => {
							const start = moment().subtract(1, "weeks").format("YYYY-MM-DD");
							const end = moment().format("YYYY-MM-DD");
							setStartDate(start);
							setEndDate(end);
						}}
					>
						1 tuần
					</Button>
					<Button
						style={{ width: "100px", marginRight: "4px" }}
						onClick={() => {
							const start = moment().subtract(1, "days").format("YYYY-MM-DD");
							const end = start;
							setStartDate(start);
							setEndDate(end);
						}}
					>
						Hôm qua
					</Button>
					<Button
						style={{ width: "100px", marginRight: "4px" }}
						onClick={() => {
							const start = moment().format("YYYY-MM-DD");
							const end = moment().format("YYYY-MM-DD");
							setStartDate(start);
							setEndDate(end);
						}}
					>
						Hôm nay
					</Button>
				</Col>
			</Row>
			{children}
		</Card>
	);
};
